<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="openModel">绑定商品</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :columns="columns"
      base-key="proUrl"
      params-path="wisdom/query/providerProduct/list"
    >
      <span slot="action" slot-scope="rowItem">
        <a @click="unbind(rowItem.record.providerProductId)">删除绑定</a>
      </span>
    </custom-page-table>
    <a-modal title="商品绑定" :width="666" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model :model="bindForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="所属供应商">
          <a-select v-model="bindForm.providerProductProviderId" placeholder="请选择供应商">
            <a-select-option v-for="item in providerList" :key="item.providerId" :value="item.providerId">
              {{ item.providerName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关联商品：">
          <a-button type="primary" @click="toSelectedProductEvent">选择商品</a-button>
          <span style="margin-left: 10px;">*仅能关联门票类型且未上架的自有商品</span>
        </a-form-model-item>
        <a-form-model-item v-if="selectedProduct.proName" label="商品名称">
          <span style="margin-left: 10px;">{{ selectedProduct.proName }}</span>
        </a-form-model-item>
        <a-form-model-item label="选择票型">
          <a-select v-model="bindForm.providerProductOptionId" placeholder="请选择票型">
            <a-select-option v-for="item in optionList" :key="item.optionId" :value="item.optionId">
              {{ item.optionName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="供应商票型ID(商品编号)">
          <a-input v-model="bindForm.providerProductDealId" placeholder="请输入供应商票型ID(商品编号)"></a-input>
        </a-form-model-item>
        <div style="text-align: center;">
          <a-button type="primary" @click="updateBindingProduct()">保存设置</a-button>
        </div>
      </a-form-model>
    </a-modal>
    <a-modal title="商品选择" :width="900" :footer="null" :visible="productVisible" @cancel="productCancel">
      <a-form layout="inline">
        <a-form-item label="商品ID">
          <a-input v-model="queryParams.proId" placeholder="请输入商品ID"></a-input>
        </a-form-item>
        <a-form-item label="商品名称">
          <a-input v-model="queryParams.proName" placeholder="请输入商品名称"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="$refs.productList.refresh(true)">
            查询
          </a-button>
        </a-form-item>
      </a-form>
      <custom-page-table
        :queryParams="queryParams"
        style="margin-top: 16px;"
        ref="productList"
        :columns="columnsProduct"
        base-key="proUrl"
        params-path="wisdom/query/pro/list"
      >
        <span slot="index" slot-scope="rowItem">{{ rowItem.index + 1 }}</span>
        <span slot="action" slot-scope="rowItem">
          <a @click="onSourceItemClick(rowItem.record)">选择</a>
        </span>
      </custom-page-table>
    </a-modal>
  </a-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'zhiyoubaoConnection',
  data() {
    return {
      labelCol: { span: 7 },
      wrapperCol: { span: 14 },
      queryParams: {},
      columns: [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '票型',
          dataIndex: 'optionName'
        },
        {
          title: '类型',
          dataIndex: 'proCatalogName'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '供应商名称',
          dataIndex: 'providerName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsProduct: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      selectedType: 0,
      visible: false,
      productVisible: false,
      bindForm: {
        providerProductMerchantId: '', //运营商Id ,
        providerProductProviderId: undefined, //: 关联账号Id(供应商Id)
        providerProductDealId: '', //供应商票型Id ,
        providerProductOptionId: undefined, //票型Id ,
        providerProductProId: '' //商品ID ,
      },
      providerList: [],
      selectedProduct: {},
      optionList: []
    }
  },
  computed: {
    ...mapState({
      vesion: state => state.config.serverDataInfo.vesion
    })
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'YzhConnection', title: '商品绑定' },
      { name: 'OrderConnection', title: '订单直连' },
      { name: 'AddAccount', title: '关联账号' }
    ])
  },
  methods: {
    //选择商品
    toSelectedProductEvent() {
      this.productVisible = true
    },
    //商品数据点击
    onSourceItemClick(item) {
      this.selectedProduct = item
      this.getOptionList(item.proId)
      this.bindForm.providerProductOptionId = undefined
      this.bindForm.providerProductProId = item.proId
      this.productVisible = false
    },
    //保存（更新绑定商品）
    updateBindingProduct() {
      if (!this.bindForm.providerProductProviderId) {
        this.$message.error('请选择关联的运营商 ')
        return
      }
      if (!this.bindForm.providerProductProId) {
        this.$message.error('请选择要绑定的商品')
        return
      }
      if (!this.bindForm.providerProductOptionId) {
        this.$message.error('请选择票型')
        return
      }
      if (!this.bindForm.providerProductDealId) {
        this.$message.error('请输入供应商票型ID')
        return
      }

      this.bindForm.providerProductMerchantId = this.merchantId
      this.getHttpServices()
        .getProService()
        .post('/wisdom/add/providerProduct', this.bindForm)
        .then(res => {
          this.$message.success('绑定成功')
          this.visible = false
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.$message.error('绑定失败')
        })
    },
    //解除绑定
    unbind(providerProductId) {
      this.getHttpServices()
        .getProService()
        .get('wisdom/del/providerProduct/' + providerProductId)
        .then(res => {
          this.$message.success('解除成功')
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    getOptionList(proId) {
      this.getHttpServices()
        .getProService()
        .post('product/option/getOptionListByProId/1/100/' + proId)
        .then(res => {
          this.optionList = res.data
          //this.bindForm.providerProductOptionId = undefined
        })
        .catch(err => {
          this.getLogUtils().logWithTag('err', err)
        })
    },
    //获取供应商列表
    getProviderList() {
      this.getHttpServices()
        .getProService()
        .get('wisdom/query/provider/list/1/200')
        .then(res => {
          this.providerList = res.data
        })
        .catch(err => {
          this.getLogUtils().logWithTag('err', err)
        })
    },
    productCancel() {
      this.productVisible = false
    },
    //关联账号
    addAccount() {
      this.$router.push({
        name: 'AddAccount',
        query: {
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    openModel() {
      this.visible = true
      this.getProviderList()
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style scoped></style>
